export default "__VITE_ASSET__99cfba66__"